import { useRouter } from 'next/router';
import { ReactNode, useEffect } from 'react';
import { useForm, useFormContext } from 'react-hook-form';
import { WafFriendlyPass } from 'src/types/waf-friendly-pass';
import styles from './style.module.scss';

type Props = {
  name: string
  label: string
  items: WafFriendlyPass.taxonomy[]
}

const SearchQuerySelect: React.VFC<Props> = ({ name, items, label }) => {
  const { register } = useFormContext();

  return (
    <label className={styles.searchQuerySelectStack}>
      <select
        {...register(name)}
        className={styles.searchQuerySelect}
      >
        <option defaultValue="0" label={label}></option>
        {items.map((item, idx) => (
          <option
            value={item.id}
            key={idx}
          >
            {item.name}
          </option>
        ))}
      </select>
    </label>
  )
}

export { SearchQuerySelect }
